export default __webpack_public_path__ + "static/media/voha-5.5b9ea319.png";